import { __, sprintf } from '@wordpress/i18n';

export const numbersValidator = () => (value) => {
  if (!/^\d+$/gi.test(String(value))) {
    throw new Error( __('Value must be a number','cooperpetcare'));
  }
};

export const maxValueValidator = (maxValue) => (value) => {
  if (value > maxValue) {
    throw new Error(
      sprintf(__('Value must be less or equal to %s','cooperpetcare'), maxValue)
    );
  }
};

export const minValueValidator = (minValue) => (value) => {
  if (value <= minValue) {
    throw new Error(
      sprintf(__('Value must be greater than %s', 'cooperpetcare'), minValue)
    );
  }
};

export const minDateValueValidator = (minValue) => (value) => {
  if (value <= minValue) {
    throw new Error(
      sprintf(__('Date must be greater than %s', 'cooperpetcare'), minValue)
    );
  }
};

export const requiredFieldValidator = () => (value) => {
  if (!value) {
    throw new Error( __('Required field', 'cooperpetcare'));
  }
};

export const validate = (form, rules) => {
  return Object.entries(rules).reduce((errors, [fieldKey, validation]) => {
    if (!Array.isArray(validation)) {
      const validator = validation;
      try {
        validator(form[fieldKey]);
      } catch (err) {
        errors[fieldKey] = err.message;
      }
    } else {
      validation.forEach((validator) => {
        try {
          validator(form[fieldKey]);
        } catch (err) {
          errors[fieldKey] = err.message;
        }
      });
    }

    return errors;
  }, {});
};
